import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SecurityTypePermission } from 'src/app/models/user-access.model';
import { Observable, switchMap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthAPIMService } from '../authAPIMService/authAPIM.service';

@Injectable({
  providedIn: 'root'
})
export class UserAccessSvc {
  private baseHeaders = new HttpHeaders({
    'Ocp-Apim-Subscription-Key': environment.subscriptionKey
  });

  constructor(private httpClient: HttpClient, private authAPIMService: AuthAPIMService) {}

  getUserSecTypes(upn: string, region: 'NA' | 'East' = 'NA'): Observable<SecurityTypePermission[]> {
    const pelotonAdmin = region === 'East' ? 'PelotonAdminV21East' : 'pelotonAdminV21Na';
    return this.authAPIMService.getAccessToken().pipe(
      switchMap(token => {
        if (!token) {
          return throwError(() => new Error('Unable to acquire access token for security types request.'));
        }

        const headers = this.baseHeaders.set('Authorization', `Bearer ${token}`);
        return this.httpClient.get<SecurityTypePermission[]>(
          `${environment.apiUrlAzure}/api/${pelotonAdmin}/SecTypes/${encodeURIComponent(upn)}?key=1&shortversion=true`,
          { headers }
        );
      })
    );
  }
}
